import { Component, ViewChild } from '@angular/core';
import { SeoService } from '../../services/seo/seo.service';
import { WindowrefService } from '../../services/windowref/windowref.service';
import { FooterComponent } from '../../components/footer/footer.component';
import { NucamptopnavComponent as NucamptopnavComponent_1 } from '../../components/nucamptopnav/nucamptopnav.component';
import { IonicModule } from '@ionic/angular';

/**
 * Generated class for the PrivacyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/*@IonicPage({
  name: 'PrivacyPage', 
  segment: 'privacy',
  priority: 'off'
})*/
@Component({
    styleUrls: ['./privacy.page.scss'],
    selector: 'page-privacy',
    templateUrl: 'privacy.page.html',
    standalone: true,
    imports: [
        IonicModule,
        NucamptopnavComponent_1,
        FooterComponent,
    ],
})
export class PrivacyPage {
  @ViewChild("nucamptopnav") NucamptopnavComponent;
  pagename= "PrivacyPage";
  scrolled: boolean;

  constructor(
    private seo: SeoService,
    private windowRef: WindowrefService) {
  }
  logScrolling($event) {
    if ($event.detail.scrollTop > 1) {
      this.scrolled = true
    } else {
      this.scrolled = false
    }
  }

  ionViewDidEnter(){
    this.seo.setCanonicalURL();
    this.seo.generateTags(
      {
        title: 'Privacy Statement',
        description: "Our privacy statement protects our users",
        image: `${this.windowRef.nativeLocation.protocol}//${this.windowRef.nativeLocation.host}/assets/imgs/opengraph/homepage.webp`,
        slug: 'privacy'
      }, null);
  }
  
  ionViewWillLeave(){
    this.seo.removeCanonicalURL();
  }

}
